<template>
    <div class="chart-wrap">
        <div class="chart" ref="chart" v-show="!isEmpty"></div>
        <no-result v-show="isEmpty"></no-result>
    </div>
</template>

<script>
    import NoResult from '../../../components/common/NoResult'
    import '@/common/js/common-plugins';
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";

    const option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                crossStyle: {
                    color: '#999'
                }
            }
        },
        toolbox: {
            feature: {
                // magicType: {show: true, type: ['line', 'bar']},
                // restore: {show: true},
                saveAsImage: {show: true,pixelRatio:2,name:'各机构走势图TOP10-会员量' +   new Date().format('yyyyMMddHHmmss')}
            },
            right:20
        },
        legend: {
            data:['注册','已实名','升级','会员量']
        },
        xAxis: [
            {
                type: 'category',
                // data: ['信创圈','信创圈2','信创圈3','信创圈4','信创圈5','信创圈6','信创圈7','信创圈8','信创圈9','信创圈10'],
                axisPointer: {
                    type: 'shadow'
                }
            }
        ],
        yAxis: [{
            type: 'value',
            name: '单位：个',
        }],
        // series: [],
        color:['#a2d148','#FF6867','#FFAE2E','#2f4554']
    };


    export default {
        name: "TopMemChart",
        components: {
            NoResult
        },
        data() {
            return {
                isEmpty: false,

            };
        },
        props:{
            params:{
                type:Object,
                default:() => {},
            }
        },
        mounted() {
            this.init(); // 初始化图表
            // this.getData(this.params); //获取图表所需数据
        },
        watch:{
            params(newVal,oldVal){
                if (newVal) {
                    this.getData(newVal); //获取图表所需数据
                } else {
                    this.getData(oldVal); //获取图表所需数据
                }
            },
        },
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        methods: {
            init() {
                this.charts = this.$echarts.init(this.$refs.chart);
                this.charts.setOption(option);
            },
            getData(params){
                // if (params.length == 0) {
                //     this.isEmpty = true;
                // } else {
                //     this.isEmpty = false;
                // }
                if(params.nameList.length == 0){
                    this.isEmpty = true;
                } else {
                    this.isEmpty = false;
                }
                this.charts.setOption(option);
                this.formatData(params); // 图表数据
            },
            formatData(data) {
                this.charts.setOption({
                    series: [
                        {
                            name:'注册',
                            type:'bar',
                            data:data.regisList
                        },
                        {
                            name:'已实名',
                            type:'bar',
                            data:data.authList
                        },
                        {
                            name:'升级',
                            type:'bar',
                            data:data.lvUpList
                        },
                        // {
                        //     name:'会员量',
                        //     type:'line',
                        //     data:[2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5]
                        // }
                    ],
                    xAxis:  {
                        data: data.nameList
                    },
                });
            },

        }
    };

</script>

<style scoped>
    .chart-wrap{
        width: 100%;
        height: 500px;
    }
    .chart{
        width: 100%;
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/view/fragment/echarts/TopMemChart.vue